// GA4 view_item
dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item",
    ecommerce: {
        currency: Shopify.currency.active,
        value: activeVariant.price / 100,
        items: [
            {
                item_id: product.id,
                item_name: product.title,
                item_category: product.type,
                item_variant: activeVariant.title,
                price: activeVariant.price / 100,
                quantity: 1
            }
        ]
    }
});


document.addEventListener("DOMContentLoaded", async function () {
    // random number gen (23-100) for checking out now text
    document.querySelectorAll(".productContentCheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
    // Do it every 3 seconds
    setInterval(function () {
        document.querySelectorAll(".productContentCheckingOutNum").forEach(function (element) {
            element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
        });
    }, 3000);
});



document.addEventListener("DOMContentLoaded", function () {

    // init swipers
    document.querySelectorAll('.productInnerGallery').forEach(element => {

        let swiper = new Swiper(element.querySelector('.productInnerGallerySwiper'), {
            navigation: {
                nextEl: element.querySelector('.swiper-button-next'),
                prevEl: element.querySelector('.swiper-button-prev'),
            }
        })

        // Thumbs
        element.querySelectorAll(`.productInnerGalleryThumbsThumbnail`).forEach(function (element) {
            element.addEventListener("click", function () {
                // change active slide
                swiper.slideTo(parseInt(this.dataset.index));
            });
        });
    });
});


/**************
 Timer
 ***************/
(function () {
    // countdown timer
    function startTimer() {
        timer = setInterval(() => {
            // convert string xx:xx time to MS
            let time = document.querySelector("#announcementTime").innerHTML;
            let splitTime = time.split(':');
            let timeMs = (splitTime[0] * 60000) + (splitTime[1] * 1000);
            // increment time
            if (timeMs > 0) {
                timeMs -= 1000;
            } else {
                // remove timer, stop setInterval
                document.querySelector("#announcement").classList.remove('active');

                stopTimer();
            }

            // convert MS to xx:xx format
            let minutes = Math.floor(timeMs / 60000);
            let seconds = ((timeMs % 60000) / 1000).toFixed(0);

            // fix time formatting
            if (seconds < 10) {
                seconds = "0" + seconds
            }
            newTime = minutes + ":" + seconds;
            document.querySelector("#announcementTime").innerHTML = newTime;
        }, 1000);
    }

    // start timer
    startTimer()

    // stop timer
    function stopTimer() {
        clearInterval(timer)
    }
}())


/**************
 QUIZ
 ***************/

// enable swiper
let productQuiz = new Swiper("#productQuiz", {
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 30
});

// update active variant on click
document.querySelectorAll(".productQuizSlideLabel").forEach(function (element) {
    element.addEventListener("click", function () {

        const group = this.dataset.group;

        // remove active class from all items in this group
        document.querySelectorAll(`.productQuizSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

        // add active class to this item
        this.classList.add("active");

        // go to next slide
        productQuiz.slideNext();

        // check if every group has an active item
        if (document.querySelectorAll(".productQuizSlide").length === document.querySelectorAll(".productQuizSlideLabel.active").length) {
            document.querySelector("#productQuiz").classList.remove("active");
            document.querySelector("#productForm").classList.add("active");
        } else {
            document.querySelector("#productQuiz").classList.add("active");
            document.querySelector("#productForm").classList.remove("active");
            return;
        }

        // create options object
        let options = {};
        document.querySelectorAll(`.productQuizSlideLabel.active`).forEach(element => {
            options[element.dataset.group] = element.dataset.value;
        });

        // use the options to select a product on the form

        // one-time/sub
        if (options.subscription === "once") {
            document.querySelector(".productSellingLabelInput[value='once']").click();
        }

        // household
        if (options.people === "1") {
            // 12 tubes / year
            document.querySelector(".productOptionItemValuesLabelInput[value='12']").click();
            document.querySelector(".productSellingLabelBodyBottomWrapContentSelect option[value='Every Year']").selected = true;
        } else if (options.people === "2") {
            // 24 tubes / year
            document.querySelector(".productOptionItemValuesLabelInput[value='24']").click();
            document.querySelector(".productSellingLabelBodyBottomWrapContentSelect option[value='Every Year']").selected = true;
        } else if (options.people === "3") {
            // 24 tubes / 9mo
            document.querySelector(".productOptionItemValuesLabelInput[value='24']").click();
            document.querySelector(".productSellingLabelBodyBottomWrapContentSelect option[value='Every 9 Months']").selected = true;
        } else if (options.people === "4") {
            // 24 tubes / 6mo
            document.querySelector(".productOptionItemValuesLabelInput[value='24']").click();
            document.querySelector(".productSellingLabelBodyBottomWrapContentSelect option[value='Every 6 Months']").selected = true;
        } else {
            // 24 tubes / 3mo
            document.querySelector(".productOptionItemValuesLabelInput[value='24']").click();
            document.querySelector(".productSellingLabelBodyBottomWrapContentSelect option[value='Every 3 Months']").selected = true;
        }

        // flavor
        if (options.flavor === "peppermint") {
            document.querySelector(".productFlavorLabelInput[value='Peppermint']").click();
        } else if (options.flavor === "mild") {
            document.querySelector(".productFlavorLabelInput[value='Mild Peppermint']").click();
        }
    });
})


// back button
document.querySelectorAll(".productQuizSlideNavBack").forEach(function (element) {
    element.addEventListener("click", function () {
        productQuiz.slidePrev();
    });
});

// next button
document.querySelectorAll(".productQuizSlideNavNext").forEach(function (element) {
    element.addEventListener("click", function () {
        productQuiz.slideNext();
    });
});


/****************
 Update Product
 *******************/

// listen for flavor change
document.querySelectorAll(".productFlavorLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {

        // update the swiper for this flavor
        document.querySelectorAll('.productInnerGallery').forEach(function (element) {
            element.classList.remove("active");
        })
        document.querySelector(`.productInnerGallery[data-target="${element.dataset.target}"]`).classList.add("active");

        // update reviews
        document.querySelectorAll('.productRatings').forEach(function (element) {
            element.classList.remove("active");
        })
        document.querySelector(`.productRatings[data-id="${element.dataset.target}"]`).classList.add("active");

        updateProduct()
    })
})


// listen for size change
document.querySelectorAll(".productOptionItemValues").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct()
    })
})

// listen for one time / sub change
document.querySelectorAll(".productSellingLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct()
    })
})

// listen for subscription option change
document.querySelectorAll(".productSellingLabelBodyBottomWrapContentSelect").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct()
    })
})

let activeProduct;

function updateProduct() {
    // find the correct product based on the selected options
    // narrow down the possible products to find the correct one

    let possibleProducts = oneTimeProducts;
    possibleProducts.push(...subscriptionProducts);

    // find flavor
    let flavor = document.querySelector(".productFlavorLabelInput:checked").value;
    possibleProducts = possibleProducts.filter(product => product.title.includes(flavor));

    // find size
    let size = document.querySelector(".productOptionItemValuesLabelInput:checked").value;
    possibleProducts = possibleProducts.filter(product => product.title.includes(size));

    // At this level there are two possible products,
    // the one time and subscription versions of the same product
    // find the one time and subscription versions of the active product
    let subscriptionProduct = possibleProducts.find(product => product.title.includes('(Subscription)'));
    let oneTimeProduct = possibleProducts.find(product => !product.title.includes('(Subscription)'));

    // Find Active Product
    activeProduct = oneTimeProduct;

    let subscriptionChecked = document.querySelector(".productSellingLabelInput:checked").value === "sub";

    if (subscriptionChecked) {
        activeProduct = subscriptionProduct;
    }
    activeVariant = activeProduct.variants[0];


    // unless flavor is wintergreen show sold out
    document.querySelector(".productContentOrder").classList.remove("active");
    document.querySelector(".productBannerBodyLeftTitleCollectionInner").classList.remove("active");

    if(flavor === "Wintergreen"){
        document.querySelector(".productContentOrder").classList.add("active");
        document.querySelector(".productBannerBodyLeftTitleCollectionInner").classList.add("active");
        document.querySelector(".productBannerBodyLeftTitleCollectionTxt").textContent = "BEST SELLER";
    }
    else if (flavor === "Peppermint"){
        document.querySelector(".productBannerBodyLeftTitleCollectionTxt").textContent = "BEST SELLER";
    }else{
        document.querySelector(".productBannerBodyLeftTitleCollectionTxt").textContent = "VERY POPULAR";

    }



    /**************
     Update Prices
     ***************/

    // update per prices inside the tube quantity selector
    let targetProducts = subscriptionChecked ? subscriptionProducts : oneTimeProducts;
    let twelveEl = document.querySelector(".productOptionItemValuesLabel.twelve");
    let twentyFourEl = document.querySelector(".productOptionItemValuesLabel.twentyFour");

    let tubesQty = parseInt(document.querySelector(".productOptionItemValuesLabelInput:checked").value);

    document.querySelectorAll(".tubeSize").forEach(function (element) {
        element.textContent = `${tubesQty} Tubes`;
    })



    // find the separate tube products (12 or 24) for the selected buy option (one time or subscription)
    let twelveTubeProduct = targetProducts.filter(product => product.title.includes('12'));
    let twentyFourTubeProduct = targetProducts.filter(product => product.title.includes('24'));

    // filter it by the selected flavor
    twelveTubeProduct = twelveTubeProduct.find(product => product.title.includes(flavor));
    twentyFourTubeProduct = twentyFourTubeProduct.find(product => product.title.includes(flavor));

    // Per Tube Price
    twelveEl.querySelector('.productOptionItemValuesLabelBodyWrapInnerSupply').textContent = `${price(twelveTubeProduct.price /12, true)} Per Tube`;
    twentyFourEl.querySelector('.productOptionItemValuesLabelBodyWrapInnerSupply').textContent = `${price(twentyFourTubeProduct.price /24, true)} Per Tube`;

    // Per Brushing Price
    twelveEl.querySelector('.productOptionItemValuesLabelBodyWrapInnerPer').textContent = `${price(twelveTubeProduct.price /12/90, true)} Per Brushing`;
    twentyFourEl.querySelector('.productOptionItemValuesLabelBodyWrapInnerPer').textContent = `${price(twentyFourTubeProduct.price /24/90, true)} Per Brushing`;



    let comparePrice = 84000;
    if(tubesQty === 12){
        comparePrice = 42000;
    }

    // Sub prices
    document.querySelector('.productSellingLabelBodyPriceReal.sub').textContent = price(subscriptionProduct.price);
    document.querySelector('.productSellingLabelBodyPriceCompare.sub').textContent = `${price((comparePrice),true )}`;

    // One time prices
    document.querySelector('.productSellingLabelBodyPriceReal.once').textContent = price(oneTimeProduct.price);
    document.querySelector('.productSellingLabelBodyPriceCompare.once').textContent = `${price((comparePrice) ,true)} `;


    // double check the price

    // cut off decimal
    let savingPrice = price(comparePrice - subscriptionProduct.price,true)
    savingPrice = savingPrice.split(".")[0];
    document.querySelector('.productSellingLabelBodyBottomWrapContentBulletsItemSaveAmount.sub').textContent = savingPrice

    document.querySelector('.productSellingLabelBodyBottomWrapContentBulletsItemSaveAmount.once').textContent = price(comparePrice - oneTimeProduct.price).split(".")[0];

    // Save amount
    document.querySelectorAll('.productOptionItemValuesLabelBodyWrapSave').forEach(element => {
        element.textContent = `Save ${savingPrice} `;
    })

    if(!subscriptionChecked){
        document.querySelectorAll('.productOptionItemValuesLabelBodyWrapSave').forEach(element => {
            element.textContent = `Save ${price(comparePrice - oneTimeProduct.price).split(".")[0]}`;
        })
    }


    // load banner
    document.querySelector('.productBannerBodyLeftImg').src = document.querySelector('.productInnerGallery.active').querySelector('.productInnerGallerySwiperImage').src;
    document.querySelector('.productBannerBodyRightATCCompare').textContent = price(comparePrice);
    document.querySelector('.productBannerBodyRightATCPrice').textContent = price(activeVariant.price);

    document.querySelector('.productBanner').classList.add('enabled');
}

// after 30 seconds have passed OR the user has scrolled 40% of page
// show the product banner
let scrollTimer = setTimeout(function () {
    document.querySelector('.productBanner').classList.add('active');
}, 30000);

// listen for scroll
window.addEventListener('scroll', function () {
    // get scroll position
    let scrollPosition = window.scrollY + window.innerHeight;
    let documentHeight = document.documentElement.scrollHeight;
    let scrollPercent = (scrollPosition / documentHeight) * 100;
    // if scrolled 40% of page, show the banner
    if (scrollPercent > 40) {
        document.querySelector('.productBanner').classList.add('active');
        clearTimeout(scrollTimer);
    }

})



// update pricing on load
updateProduct();


/*************
 Default Quantity
 **************/

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelectorAll(".productATC").forEach(async function (element) {
    element.addEventListener("click", async function () {

        let sellingPlan;

        // check if selling plan is selected
        if (document.querySelector(".productSellingLabelInput:checked").value === "sub") {
            // find the selling plan
            activeProduct.selling_plan_groups[0].selling_plans.forEach(function (plan) {
                if (plan.name === document.querySelector(".productSellingLabelBodyBottomWrapContentSelect").value) {
                    sellingPlan = plan.id
                }
            })
        }

        // create formdata
        let formData = {
            quantity: 1,
            id: activeVariant.id,
            selling_plan: sellingPlan
        };

        // add loading animation
        this.classList.add("loading");

        // GA4 add_to_cart
        const sourceProduct = variantToSourceProduct[formData.id];
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();

    });
});


/************
 Dynamic Sold Out
 ************/
(function () {
    // Get the current date and time
    let currentDate = new Date();
    // let currentDate = new Date("2024-05-29T23:59:00");

    // The date everything is relative to - which is a Sunday.
    let targetDate = new Date("2024-04-28T23:59:00");

    // Increment the counter for every day that has passed
    let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

    // get the next monday from current date
    let nextMonday = new Date(currentDate);
    nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

    // get the last monday from current date
    let lastMonday = new Date(currentDate);
    lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

    // Update the text with the incremented number
    document.querySelectorAll(".percentSold")?.forEach(function (element) {
        element.textContent = daysPassed + 91;
    });

    // Update the date with the next monday
    document.querySelectorAll(".preOrderDate")?.forEach(function (element) {
        element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
    });

    // Update the date with the last Monday
    document.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
        element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
    });

    document.querySelector('.productBannerBodyLeftTitleCollectionInner').textContent = `- NEXT BATCH SHIPS ${nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'})}`;

})();



/**************
 Product Banner ATC
 ***************/



document.querySelectorAll('.productBannerBodyRightATC').forEach(function (el) {
    el.addEventListener('click', function () {
        // add loading animation
        this.classList.add('loading');

        // click real atc since we're synced
        document.querySelector('.productATC').click();

        // wait 1 second
        setTimeout(function () {
            // remove loading animation
            el.classList.remove('loading');
        }, 1000);
    });
});